// const playPauseBtn = document.querySelectorAll('.play-pause-btn-audio');
// playPauseBtn.forEach(playBtn => {
//     playBtn.addEventListener('click', function() {
        
//         const audioParent = this.closest(".feet-thumbnails-audio");
//         const audio = audioParent.querySelector(".audio");
//         const playIcon = audioParent.querySelector(".play-icon-audio"); 
//         const waveProgress = audioParent.querySelector('.wave-progress');

//         // // Play/Pause functionality
//           if (audio.paused) {
//             audio.play();
//             playIcon.src = 'https://cdn.shopify.com/s/files/1/0658/9733/2918/files/Pause.svg?v=1724334216'; // Update with your pause icon path
//           } else {
//             audio.pause();
//             playIcon.src = 'https://cdn.shopify.com/s/files/1/0658/9733/2918/files/play-icon-audio.png?v=1724336383'; // Update with your play icon path
//           }
//         // // Update progress bar as audio plays
//         if(audio){
//           audio.addEventListener('timeupdate', function() {
//                 const progressPercentage = (audio.currentTime / audio.duration) * 100;
//                 waveProgress.style.width = progressPercentage + '%';
//               });
//         }
//     })
// })




let currentAudio = null; // Variable to store the currently playing audio

const playPauseBtn = document.querySelectorAll('.play-pause-btn-audio');
playPauseBtn.forEach(playBtn => {
    playBtn.addEventListener('click', function() {
        const audioParent = this.closest(".feet-thumbnails-audio");
        const audio = audioParent.querySelector(".audio");
        const playIcon = audioParent.querySelector(".play-icon-audio");
        const waveProgress = audioParent.querySelector('.wave-progress');

        // Stop any currently playing audio
        if (currentAudio && currentAudio !== audio) {
            currentAudio.pause();
            const currentAudioParent = currentAudio.closest(".feet-thumbnails-audio");
            const currentPlayIcon = currentAudioParent.querySelector(".play-icon-audio");
            currentPlayIcon.src = 'https://cdn.shopify.com/s/files/1/0658/9733/2918/files/play-icon-audio.png?v=1724336383';
            currentAudio.currentTime = 0; // Optional: reset the current audio's time
        }

        // Play/Pause functionality for the clicked audio
        if (audio.paused) {
            audio.play();
            playIcon.src = 'https://cdn.shopify.com/s/files/1/0658/9733/2918/files/Pause.svg?v=1724334216';
            currentAudio = audio; // Set the new current audio
        } else {
            audio.pause();
            playIcon.src = 'https://cdn.shopify.com/s/files/1/0658/9733/2918/files/play-icon-audio.png?v=1724336383';
            currentAudio = null; // Reset if no audio is playing
        }

        // Update progress bar as audio plays
        if (audio) {
            audio.addEventListener('timeupdate', function() {
                const progressPercentage = (audio.currentTime / audio.duration) * 100;
                waveProgress.style.width = progressPercentage + '%';
            });
        }

        // Allow seeking by clicking on the waveform
        const waveform = audioParent.querySelector('.audio-waveform');
        waveform.addEventListener('click', function(event) {
            const waveformWidth = waveform.offsetWidth;
            const clickPosition = event.offsetX; // Get the position where the user clicked
            const newTime = (clickPosition / waveformWidth) * audio.duration; // Calculate the new time in seconds
            audio.currentTime = newTime; // Set the audio to the new time
        });
    });
});
